import { render, staticRenderFns } from "./ComponentReplaceDialog.vue?vue&type=template&id=5329869a&scoped=true&"
import script from "./ComponentReplaceDialog.vue?vue&type=script&lang=js&"
export * from "./ComponentReplaceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329869a",
  null
  
)

export default component.exports